export default __webpack_public_path__ + "static/media/airbnb1.cb04b612.jfif";